export enum ProgramMedicinesTableColumnDataIndex {
  ProtectedDrugName = "protectedDrugName",
  Type = "type",
  Inn = "inn",
  UsageRegime = "usageRegime",
  UsageDayPeriod = "usageDayPeriod",
  Option = "option",
}
